import { Bot, BrainCircuit, ShieldCheck } from 'lucide-react'

export type NewsEditionTab = 'ai' | 'robots' | 'cybersecurity'

export function NewsEditionSwitch({ activeEdition }: { activeEdition: NewsEditionTab }) {
  const editions = [
    { id: 'ai' as const, href: '/news', number: '01', label: 'AI', description: 'Models · compute · power', Icon: BrainCircuit },
    { id: 'robots' as const, href: '/news/robots', number: '02', label: 'Robotics', description: 'Embodied AI · machines', Icon: Bot },
    { id: 'cybersecurity' as const, href: '/news/cybersecurity', number: '03', label: 'Cyberdefense', description: 'Threats · defense · resilience', Icon: ShieldCheck },
  ]

  return <nav className="news-edition-switch" aria-label="Choose coverage desk">
    {editions.map(({ id, href, number, label, description, Icon }) => {
      const active = activeEdition === id
      return <a href={href} data-edition={id} aria-label={`${label} coverage desk${active ? ', current desk' : ''}`} aria-current={active ? 'page' : undefined} className={active ? 'is-active' : ''} key={id}>
        <span className="news-edition-switch__number">{number}</span>
        <Icon aria-hidden="true"/>
        <span className="news-edition-switch__copy"><strong>{label}</strong><small>{description}</small></span>
        <b>{active ? 'CURRENT DESK' : 'OPEN DESK'}</b>
      </a>
    })}
  </nav>
}
